(($)=>{
    "use strict";

    $('.hero-blue .down').on('click', function(event) {
        event.preventDefault();

        const headerHeight = $('.site-header .header-content').height();

        const $hero = $(this).closest('.hero-blue');
        const heroTop = $hero.offset().top;
        const heroHeight = $hero.height();


        const contentOffset = heroTop + heroHeight - headerHeight;

        $('html, body').stop().animate({scrollTop: contentOffset}, 500, 'swing');
    });

    // lets init inner slider.
    const $el  = $('[data-content-slider]');
    const slidingTimeout = 4500; // was 3500

    if (0 === $el.length) return;

    const $buttons = $('a.content-slider-link', $el);
    const $slides = $('.content-slide', $el);

	$slides.eq(0).addClass('active');

	var currentCertSlide = 0,
		nextCertSlide;

	function certSlider( newSlide ) {
		nextCertSlide = newSlide;

		//$slides.eq(currentCertSlide).addClass('out');
		//$slides.eq(nextCertSlide).addClass('in');

		setTimeout( function() {
			$slides.eq(nextCertSlide).addClass('active');
			$slides.eq(currentCertSlide).removeClass('active');
			 $buttons.removeClass('active').eq(nextCertSlide).addClass('active');
			currentCertSlide = nextCertSlide;
		}, 100 );
	}

	function NextSlide () {
		if ( currentCertSlide + 1 < $slides.length ) {
			nextCertSlide = currentCertSlide + 1;
		} else {
			nextCertSlide = 0;
		}

		certSlider( nextCertSlide );
	}

	var timerSlider = setInterval( NextSlide, slidingTimeout);


    $buttons.on('click', function (event) {
		event.preventDefault();
		
		const $activatedBtn = $(this);
        const activeHref = $activatedBtn.attr('href');
        const $activatedSlide = $slides.filter(activeHref);

        $buttons.not($activatedBtn).removeClass('active');
        $activatedBtn.addClass('active');

        $slides.not($activatedSlide).removeClass('active');
        $activatedSlide.addClass('active');

		clearInterval( timerSlider );
		timerSlider = setInterval( NextSlide, slidingTimeout);

    });


})(jQuery);